export default "__VITE_ASSET__4jYGPdFM__"